import React, { useCallback } from 'react';
import { useReactFlow, type Node, type Edge } from '@xyflow/react';
import { ContextMenuProps } from './index.functions';
import styles from './index.styles';
import { uid } from 'tools/tools';
import { cloneDeep } from 'lodash';
import useBundleTranslation from 'i18n';
import { workflowAPI } from 'api/workflow';

export default function ContextMenu({
    id,
    workflowId,
    top,
    left,
    right,
    bottom,
    workflowItems,
    setWorkflowItems,
    ...props
}: ContextMenuProps) {
    const { t } = useBundleTranslation(['app/admin/editor/generic-workflow/common']);

    const { getNode, setNodes, addNodes, setEdges } = useReactFlow();

    const duplicateNode = useCallback(() => {
        const node: Node | undefined = getNode(id);
        if (!node) return;

        const position = {
            x: node.position.x + 50,
            y: node.position.y + 50,
        };

        addNodes({
            ...node,
            selected: false,
            dragging: false,
            id: uid(),
            position,
        });
    }, [id, getNode, addNodes]);

    const deleteNode = useCallback(() => {
        setNodes((nodes: Node[]) => nodes.filter((node: Node) => node.id !== id));
        setEdges((edges: Edge[]) => edges.filter((edge: Edge) => edge.source !== id && edge.target !== id));

        if (workflowItems[id]) {
            let tmpWorkflowItems = cloneDeep(workflowItems);
            delete tmpWorkflowItems[id];
            setWorkflowItems({ ...tmpWorkflowItems });

            workflowAPI.deleteItem(workflowId, id);
        }
    }, [id, setNodes, setEdges]);

    return (
        <div style={{ ...styles.contextMenu, ...{ top, left, right, bottom } }} {...props}>
            <p style={{ margin: '0.5em' }}>
                <small>
                    {t('uid')}: {id}
                </small>
            </p>
            <button style={styles.contextMenuButton} onClick={deleteNode}>
                {t('delete')}
            </button>
        </div>
    );
}
